import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Recta/calcularRecta`, method: 'POST', body: values, token: token})
}